const transfer = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M17.4142%2011L21.8284%2015.7071L17.4142%2021L15.4142%2020L18%2016.7071H5.41421V14.7071H18L15.4142%2012L17.4142%2011ZM7.41421%203L9.41421%204L6.82843%206.70711H19.4142V8.70711H6.82843L9.41421%2012L7.41421%2013L3%207.70711L7.41421%203Z'/%3e%3c/svg%3e";
export {
  transfer as default
};
//# sourceMappingURL=transfer.svg.es.js.map
